export default __webpack_public_path__ + "static/hw_leds-73eae7b17c701caec21291b3d72c19ef.jpg";